import { useEffect, useState } from 'react'
import { api } from '@/api/client'

export function CancellationBanner() {
  const [info, setInfo] = useState<{
    cancellation_effective_at?: string
    purge_at?: string
  } | null>(null)
  const [reactivating, setReactivating] = useState(false)

  useEffect(() => {
    let active = true
    const load = async () => {
      try {
        const orgId = await api.getActiveOrgId()
        const org = await api.getOrganisation(orgId)
        if (active && org.lifecycle_state === 'cancellation_pending') {
          setInfo({
            cancellation_effective_at: org.cancellation_effective_at ?? undefined,
            purge_at: org.purge_at ?? undefined,
          })
        }
      } catch { /* ignore */ }
    }
    void load()
    return () => { active = false }
  }, [])

  if (!info) return null

  const daysLeft = info.cancellation_effective_at
    ? Math.max(0, Math.ceil((new Date(info.cancellation_effective_at).getTime() - Date.now()) / (1000 * 60 * 60 * 24)))
    : null

  const handleReactivate = async () => {
    setReactivating(true)
    try {
      const orgId = await api.getActiveOrgId()
      await api.reactivateOrganisation(orgId)
      window.location.reload()
    } catch {
      setReactivating(false)
    }
  }

  return (
    <div className="flex items-center justify-between gap-4 border-b border-amber-300 bg-amber-50 px-4 py-2 text-sm dark:border-amber-800 dark:bg-amber-950/30">
      <p className="text-amber-800 dark:text-amber-200">
        This organisation is scheduled for cancellation
        {daysLeft !== null && <> in <strong>{daysLeft} days</strong></>}.
      </p>
      <button
        onClick={handleReactivate}
        disabled={reactivating}
        className="shrink-0 rounded-md bg-amber-600 px-3 py-1 text-xs font-medium text-white hover:bg-amber-700 disabled:opacity-50"
      >
        {reactivating ? 'Reactivating…' : 'Reactivate'}
      </button>
    </div>
  )
}
